export type VideoZone = 'left' | 'center' | 'right';
export function videoZone(x: number, width: number): VideoZone {
  if (width <= 0) return 'center';
  return x < width / 3 ? 'left' : x > width * 2 / 3 ? 'right' : 'center';
}
export function videoTapAction(zone: VideoZone, previous: { zone: VideoZone; at: number } | null, at: number): 'toggle' | -10 | 10 | null {
  if (zone === 'center') return 'toggle';
  return previous?.zone === zone && at - previous.at >= 0 && at - previous.at <= 300
    ? zone === 'left' ? -10 : 10 : null;
}
export function videoSeekTarget(position: number, delta: number, duration: number): number {
  if (!Number.isFinite(position) || !Number.isFinite(duration) || duration <= 0) return position;
  return Math.max(0, Math.min(duration, position + delta));
}
